import React, { useEffect, useState } from 'react';
import useAppStore from '../../../store';
import DataModeBadge from '../../../components/feedback/DataModeBadge';
import { getClient } from '../../../lib/api/clients';

/**
 * Profile / Business Profile tab (full-live-cutover §3, Settings build).
 *
 * Posture per §3: read-only from PocketBase where fields exist (the clients
 * collection row for the session tenant, resolved self-scoped server-side);
 * session-claim fallback behind the labeled mode when the record is
 * unreachable. NO profile write API this batch — the tab says so instead of
 * faking a save (the old mock "Saved (mock)" form is gone).
 */
function ProfileTab() {
  const session = useAppStore((state) => state.session);
  const tenantRecord = useAppStore((state) => state.tenantRecord);
  const [record, setRecord] = useState(null);
  const [mode, setMode] = useState('live');
  const name = session?.user?.name || '';
  const email = session?.user?.email || '';

  // Read-only fetch of the tenant's clients row (self-scoped server-side —
  // a client tenant's token resolves only its own slug).
  useEffect(() => {
    let cancelled = false;
    const tenantId = session?.tenantId || tenantRecord?.slug;
    if (!tenantId) {
      setMode('sample');
      return undefined;
    }
    getClient(tenantId)
      .then((row) => {
        if (cancelled) return;
        setRecord(row || null);
        setMode('live');
      })
      .catch(() => {
        if (cancelled) return;
        setRecord(null);
        setMode('sample');
      });
    return () => {
      cancelled = true;
    };
  }, [session?.tenantId, tenantRecord?.slug]);

  return (
    <div className="settings-tab">
      <section className="settings-section">
        <div className="section-heading">
          <div>
            <h2>
              Business profile{' '}
              <DataModeBadge
                mode={mode}
                label={mode === 'live' ? null : 'Tenant record unreachable — fields show session claims'}
              />
            </h2>
            <span>
              Identity data as it exists in the platform today. Editing waits
              for a profile write endpoint (not built this round).
            </span>
          </div>
        </div>

        <dl className="settings-profile-readonly">
          <div>
            <dt>Tenant</dt>
            <dd>{tenantRecord.name} ({tenantRecord.id})</dd>
          </div>
          <div>
            <dt>Display name</dt>
            <dd>{record?.name || '—'}</dd>
          </div>
          <div>
            <dt>Business type</dt>
            <dd>{record?.businessType || '—'}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd>{record?.status || '—'}</dd>
          </div>
          <div>
            <dt>Your name</dt>
            <dd>{name || session?.user?.email || '—'}</dd>
          </div>
          <div>
            <dt>Work email</dt>
            <dd>{email || '—'}</dd>
          </div>
        </dl>

        <p className="settings-note">
          Read-only view — writes arrive with the profile endpoint.
        </p>
      </section>
    </div>
  );
}

export default ProfileTab;
